import {useDispatch, useSelector} from "react-redux";
import logo from '../images/logo.svg'
import {menuOpenItem, mobile_guides, mobile_menu} from "../redux/actions";
import React, {useEffect} from 'react';

export const Header = () => {
    const scroll_const = 65;
    const dispatch = useDispatch()
    const locale = useSelector(state => state.app.locale)
    const configData = useSelector(state => state.app.configData)
    const isMobile = useSelector(state => state.app.isMobile)
    const mobileMenu = useSelector(state => state.app.mobileMenu)
    const mobileMenuOpenItem = useSelector(state => state.app.mobileMenuOpenItem)
    const mobileGuides = useSelector(state => state.app.mobileGuides)

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > scroll_const) {
                let elems = document.querySelectorAll(".site-header2");
                [].forEach.call(elems, function (el) {
                    el.classList.add("fixed");
                });
            } else {
                let elems = document.querySelectorAll(".site-header2");
                [].forEach.call(elems, function (el) {
                    el.classList.remove("fixed");
                });
            }
        });
    }, []);
    const handleGuidesClick = (e, checked) => {
        dispatch(mobile_guides(checked))
        return false;
    }
    const handleBurgerClick = (checked) => {
        dispatch(mobile_menu(checked))
    }
    const has_childs = (airconfig, index) => {
        let r = false;
        for (let i = 0; i < airconfig.length; i++) {
            if (airconfig[i].fields.type === 'header_sub_menu' && airconfig[i].fields.locale === locale) {
                if (airconfig[i].fields.id.indexOf('header_menu_item_' + index + '_') >= 0) {
                    r = true;
                }
            }
        }
        return r;
    }
    const handleOpenChildsClick = (has, item) => {
        if (has) {
            if (item === mobileMenuOpenItem){
                dispatch(menuOpenItem(''))
            } else {
                dispatch(menuOpenItem(item))
            }
        }
    }
    if (mobileMenu) {
        document.body.style.overflow = "hidden"
    } else {
        document.body.style.overflow = "auto"
    }
    let i1 = 0;
    if (configData !== null && configData.length > 0) {
        return (
            <React.Fragment>
                <header className="site-header container">
                    <div className="container__wrap site-header__flex">
                        {
                            configData.map((item) => {
                                if (item.fields.id === 'logo' && item.fields.locale === locale) {
                                    return (
                                        <a href={item.fields.link} key={item.fields.id} className="site-header__logo"
                                           target="_blank" rel="noopener">
                                            <img src={logo} alt={item.fields.label} title={item.fields.label}/>
                                        </a>
                                    )
                                }
                                return null;
                            })
                        }

                        {
                            !isMobile && (
                                <nav className="site-header__menu" id="site-header__menu">
                                    <ul id="menu-header" className="menu">
                                        {

                                            configData.map((item, index) => {
                                                if (item.fields.type === 'header_menu' && item.fields.locale === locale) {
                                                    let className = '';
                                                    i1++;
                                                    if (has_childs(configData, i1)) {
                                                        className = 'menu-item-has-children';
                                                    }
                                                    if (item.fields.class !== undefined) {
                                                        className += ' ' + item.fields.class;
                                                    }

                                                    return (
                                                        <li key={item.fields.id} className={className}>
                                                            <a href={item.fields.link} target="_blank" rel="noopener">
                                                                {item.fields.label}
                                                            </a>
                                                            {
                                                                has_childs(configData, i1) && (
                                                                    <ul>
                                                                        {
                                                                            configData.map((s_item, s_index) => {
                                                                                if (s_item.fields.type === 'header_sub_menu' && s_item.fields.locale === locale) {
                                                                                    if (s_item.fields.id.indexOf('header_menu_item_' + i1 + '_') >= 0) {
                                                                                        if (s_item.fields.label === 'line') {
                                                                                            return (
                                                                                                <li key={s_item.fields.id}>
                                                                                                        <span
                                                                                                            className="line"/>
                                                                                                </li>
                                                                                            )
                                                                                        }
                                                                                        if (s_item.fields.class === 'guides') {
                                                                                            return (
                                                                                                <li key={s_item.fields.id}
                                                                                                    className={s_item.fields.id + ' menu-item-has-children'}>
                                                                                                    <a href={s_item.fields.link}
                                                                                                       className={s_item.fields.class !== undefined ? s_item.fields.class : ''}
                                                                                                       target="_blank"
                                                                                                       rel="noopener">
                                                                                                        <span></span>
                                                                                                        {s_item.fields.label}
                                                                                                    </a>
                                                                                                    <ul>
                                                                                                        {
                                                                                                            configData.map((g_item, g_index) => {
                                                                                                                if (g_item.fields.type === 'guides' && g_item.fields.locale === locale) {
                                                                                                                    return (
                                                                                                                        <li
                                                                                                                            className="guides"
                                                                                                                            key={g_index}
                                                                                                                        >
                                                                                                                            <a href={g_item.fields.link}
                                                                                                                               className="menu-link">
                                                                                                                                {g_item.fields.label}
                                                                                                                                <span>download guide</span>
                                                                                                                            </a>
                                                                                                                        </li>
                                                                                                                    )
                                                                                                                }
                                                                                                                return null;
                                                                                                            })
                                                                                                        }
                                                                                                    </ul>
                                                                                                </li>
                                                                                            )
                                                                                        }

                                                                                        return (
                                                                                            <li key={s_item.fields.id}
                                                                                                className={s_item.fields.id}>
                                                                                                <a href={s_item.fields.link}
                                                                                                   className={s_item.fields.class !== undefined ? s_item.fields.class : ''}
                                                                                                   target="_blank"
                                                                                                   rel="noopener">
                                                                                                    <span></span>
                                                                                                    {s_item.fields.label}
                                                                                                </a>
                                                                                            </li>
                                                                                        )
                                                                                    }
                                                                                }
                                                                                return null
                                                                            })
                                                                        }
                                                                    </ul>

                                                                )
                                                            }

                                                        </li>
                                                    )

                                                }
                                                return null;
                                            })
                                        }
                                    </ul>
                                </nav>
                            )
                        }
                        {
                            isMobile && !mobileMenu && (
                                <div className="site-header__burger" onClick={() => handleBurgerClick(mobileMenu)}/>)
                        }
                        {
                            isMobile && mobileMenu && (
                                <div className="site-header__burger_close" onClick={() => handleBurgerClick(mobileMenu)}/>)
                        }
                    </div>
                </header>
                {
                    isMobile && mobileMenu && (
                        <div className="mobile-menu container">
                            <div className="mobile-menu__box container__wrap">
                                <nav className="mobile-menu__nav mobile-menu__nav_1">
                                    <ul>
                                        {

                                            configData.map((item, index) => {
                                                if (item.fields.type === 'mobile_menu' && item.fields.locale === locale) {
                                                    return (
                                                        <li key={item.fields.id}>
                                                            <a href={item.fields.link}
                                                               className={item.fields.class !== undefined ? item.fields.class : ''}
                                                               target="_blank" rel="noopener">
                                                                {item.fields.label}
                                                            </a>
                                                        </li>
                                                    )
                                                }
                                                return null;
                                            })
                                        }
                                    </ul>
                                </nav>
                                <nav className="mobile-menu__nav mobile-menu__nav_2">
                                    <div className="mobile-menu__nav_heading">Resources</div>
                                    <ul>
                                        {

                                            configData.map((item, index) => {
                                                if (item.fields.type === 'mobile_r_menu' && item.fields.locale === locale) {
                                                    if (item.fields.class === 'guides') {
                                                        return (
                                                            <li key={item.fields.id}
                                                                className={mobileGuides === true ? 'active' : ''}>
                                                                <span href={item.fields.link}
                                                                      className={item.fields.class !== undefined ? item.fields.class : ''}
                                                                      onClick={(e) => handleGuidesClick(e.target, mobileGuides)}
                                                                      target="_blank" rel="noopener">
                                                                    {item.fields.label}
                                                                </span>
                                                                <ul>
                                                                    {
                                                                        configData.map((s_item, s_index) => {
                                                                            if (s_item.fields.type === 'guides' && s_item.fields.locale === locale) {
                                                                                return (
                                                                                    <li
                                                                                        key={s_index}
                                                                                        className="guides">
                                                                                        <a href={s_item.fields.link}
                                                                                           className="menu-link">
                                                                                            {s_item.fields.label}
                                                                                            <span>download guide</span>
                                                                                        </a>
                                                                                    </li>
                                                                                )
                                                                            }
                                                                            return null;
                                                                        })
                                                                    }
                                                                </ul>
                                                            </li>
                                                        )
                                                    }
                                                    return (
                                                        <li key={item.fields.id}>
                                                            <a href={item.fields.link}
                                                               className={item.fields.class !== undefined ? item.fields.class : ''}
                                                               target="_blank" rel="noopener">
                                                                {item.fields.label}
                                                            </a>
                                                        </li>
                                                    )
                                                }
                                                return null;
                                            })
                                        }
                                    </ul>
                                </nav>
                                <nav className="mobile-menu__nav mobile-menu__nav_3">
                                    <div className="mobile-menu__nav_heading">Tools</div>
                                    <ul>
                                        {

                                            configData.map((item, index) => {
                                                if (item.fields.type === 'mobile_t_menu' && item.fields.locale === locale) {
                                                    return (
                                                        <li key={item.fields.id} >
                                                            <a href={item.fields.link}
                                                               className={item.fields.class !== undefined ? item.fields.class : ''}
                                                               target="_blank" rel="noopener">
                                                                {item.fields.label}
                                                            </a>
                                                        </li>
                                                    )
                                                }
                                                return null;
                                            })
                                        }
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    )
                }
            </React.Fragment>
        )
    }
    return null;
}